// @avantia common-code
export enum HpClientDebugFlags {
  None = 0,
  AddressLookup = 2 << 0,
  AjaxRequestBodies = 2 << 1,
  AjaxRequests = 2 << 2,
  BlankAnswers = 2 << 3,
  BulkRecordProcessor = 2 << 4,
  CalculatedAnswerDetail = 2 << 5,
  CalculatedAnswerParser = 2 << 6,
  CalculatedAnswers = 2 << 7,
  Configuration = 2 << 8,
  Controls = 2 << 9,
  DefaultAnswersAndDisabledExpressions = 2 << 10,
  DependentActions = 2 << 11,
  DependentAnswerDetail = 2 << 12,
  DependentAnswers = 2 << 13,
  DeveloperTemporary = 2 << 14,
  EventLog = 2 << 15,
  EventProcessor = 2 << 16,
  Gtm = 2 << 17,
  HelpInfoExpressions = 2 << 18,
  LookupExpressions = 2 << 19,
  PageLoadDataHandler = 2 << 20,
  PayloadMapper = 2 << 21,
  PrerequisiteDetail = 2 << 22,
  PrerequisiteParser = 2 << 23,
  Prerequisites = 2 << 24,
  ReducerProcessor = 2 << 25,
  ScriptActions = 2 << 26,
  TimeTaken = 2 << 27,
  UnitTests = 2 << 28,
  ValidatorExpressions = 2 << 29,
  All = AddressLookup |
    AjaxRequestBodies |
    AjaxRequests |
    BlankAnswers |
    BulkRecordProcessor |
    CalculatedAnswerDetail |
    CalculatedAnswerParser |
    CalculatedAnswers |
    Configuration |
    Controls |
    DefaultAnswersAndDisabledExpressions |
    DependentActions |
    DependentAnswerDetail |
    DependentAnswers |
    DeveloperTemporary |
    EventLog |
    EventProcessor |
    Gtm |
    HelpInfoExpressions |
    LookupExpressions |
    PageLoadDataHandler |
    PayloadMapper |
    PrerequisiteDetail |
    PrerequisiteParser |
    Prerequisites |
    ReducerProcessor |
    ScriptActions |
    TimeTaken |
    UnitTests |
    ValidatorExpressions
}
